import { styled } from '@mui/material/styles';
import { Box, Typography, Stack, Paper, Button } from '@mui/material';

export const FormContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1),
}));

export const FormFieldsContainer = styled(Box)(() => ({
  width: 900,
}));

export const FormSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

export const ButtonContainer = styled(Stack)(() => ({
  marginLeft: 'auto',
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const HeaderButton = styled(Button)(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));

// Common field styles
export const FieldContainer = styled(Box)<{ noMarginBottom?: boolean }>(
  ({ theme, noMarginBottom }) => ({
    marginBottom: noMarginBottom ? 0 : theme.spacing(1),
  }),
);

export const InlineFieldsContainer = styled(FieldContainer)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1),

  '& > :nth-child(1)': {
    width: '70%',
  },
  '& > :nth-child(2)': {
    width: '30%',
  },
}));

export const FieldsRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'flex-end',
}));
